import React, { type FC, useEffect, useState } from "react";

import { useIntl } from "react-intl";

import styled from "@emotion/styled";

import {
  DatePicker,
  Flex,
  FormElement,
  Grid,
  GridCell,
  Group,
  InputText,
  Item,
  Panel,
  SearchForm,
  Select,
  SpacingVertical,
  Text,
  Title,
} from "mailup-web-components";
import { useRecoilCallback, useRecoilState, useResetRecoilState } from "recoil";
import {
  resetSearchCallback,
  searchImportedCallback,
} from "../recoil/callbacks";
import { tableImportedSearchState } from "../recoil/state";
import { gainsightTrack } from "mailup-react-helpers";

const Search: FC = () => {
  const intl = useIntl();

  useEffect(() => {
    //TODO
  }, []);

  const [advancedSearchExpanded, setadvancedSearchExpanded] = useState(false);
  const [
    { Status, Filename, StartDateFrom, StartDateTo },
    settableImportedSearchState,
  ] = useRecoilState(tableImportedSearchState);
  const searchImported = useRecoilCallback(searchImportedCallback, []);
  const reset = useRecoilCallback(resetSearchCallback, []);

  const onChangeStatus = (val: string) => {
    gainsightTrack("mup_importStatusPage_clickImportsatusSelect", {});

    settableImportedSearchState((prev) => ({
      ...prev,
      Status: val.split(",").map(Number),
    }));
  };

  const handleChangeStartDateFrom = (v: any) => {
    gainsightTrack("mup_importStatusPage_clickImportDateFrom", {});

    settableImportedSearchState((prev) => ({
      ...prev,
      StartDateFrom: v,
    }));
  };

  const handleChangeStartDateTo = (v: Date) => {
    gainsightTrack("mup_importStatusPage_clickImportDateTo", {});

    const dateWithTime = new Date(v);
    dateWithTime.setHours(23, 59, 59, 999);

    settableImportedSearchState((prev) => ({
      ...prev,
      StartDateTo: dateWithTime,
    }));
  };

  const onChangeFIleName = (e: any) => {
    gainsightTrack("mup_importStatusPage_clickFlagSelectFile", {});

    settableImportedSearchState((prev) => ({
      ...prev,
      Filename: e.target.value,
    }));
  };

  const handleSearch = () => {
    gainsightTrack("mup_importStatusPage_clickSearch", {});

    searchImported(false, { pageNumber: 1 });
  };

  const handleReset = () => {
    gainsightTrack("mup_importStatusPage_clickReset", {});

    reset().then((ret) => {
      if (ret) {
        searchImported(false, { pageNumber: 1 });
      }
    });
  };
  const AdvancedSearchComponent = () => (
    <>
      <StyledGrid cols={12}>
        <GridCell span={12}>
          <FormElement
            label={intl.formatMessage({
              id: "Load.FileImportStatus.StausLabel",
            })}
          >
            <Select
              value={Status?.join() ?? ""}
              onChange={onChangeStatus}
              multiple={false}
              options={[
                {
                  label: intl.formatMessage({
                    id: "Load.Common.SelectAll",
                  }),
                  value: "3,4",
                },
                {
                  label: intl.formatMessage({
                    id: "Load.FileImportStatus.CompleteStatus",
                  }),
                  value: "3",
                },
                {
                  label: intl.formatMessage({
                    id: "Load.FileImportStatus.ErrorStatus",
                  }),
                  value: "4",
                },
              ]}
            />
          </FormElement>
        </GridCell>
        <GridCell span={12}>
          <Text variant="bold">
            {intl.formatMessage({
              id: "Load.FileImportStatus.DateLabel",
            })}
          </Text>
        </GridCell>
        <GridCell span={6}>
          <Flex alignItems="center" gap="8px">
            <Text variant="bold" htmlElement="span">
              {intl.formatMessage({
                id: "Load.Common.FromNumber",
              })}
            </Text>
            <StyledDatePicker
              data-mu-test="input-date-from"
              value={StartDateFrom}
              maxDate={StartDateTo !== undefined ? StartDateTo : new Date()}
              isClearable={false}
              locale={intl.locale}
              callback={handleChangeStartDateFrom}
              placeholder={intl.formatMessage({
                id: "Load.FileImportStatus.DatePlaceholder",
              })}
            />
          </Flex>
        </GridCell>
        <GridCell span={6}>
          <Flex alignItems="center" gap="8px">
            <Text variant="bold" htmlElement="span">
              {intl.formatMessage({
                id: "Load.Common.ToNumber",
              })}
            </Text>
            <StyledDatePicker
              data-mu-test="input-date-to"
              value={StartDateTo}
              minDate={StartDateFrom !== undefined ? StartDateFrom : null}
              placeholder={intl.formatMessage({
                id: "Load.FileImportStatus.DatePlaceholder",
              })}
              isClearable={false}
              locale={intl.locale}
              callback={handleChangeStartDateTo}
            />
          </Flex>
        </GridCell>
      </StyledGrid>
    </>
  );

  const handleToggleAdvancedSearch = () => {
    gainsightTrack("mup_importStatusPage_clickSearchMoreOptions", {});

    setadvancedSearchExpanded(!advancedSearchExpanded);
  };

  return (
    <>
      <Title variant="M">
        {intl.formatMessage({ id: "Load.FileImportStatus.ImportCompleted" })}
      </Title>
      <SpacingVertical variant="16" />
      <Panel>
        <SearchForm
          AdvancedSearchComponent={AdvancedSearchComponent}
          expanded={advancedSearchExpanded}
          // expanded
          labelBtnReset={intl.formatMessage({
            id: "Load.SearchRecipients.Reset",
          })}
          labelBtnSearch={intl.formatMessage({
            id: "Load.MailupCommon.Search",
          })}
          onClickToggle={handleToggleAdvancedSearch}
          onClickSubmit={handleSearch}
          onClickReset={handleReset}
        >
          <Group>
            <Item>
              <InputText
                value={Filename}
                onChange={onChangeFIleName}
                placeholder={intl.formatMessage({
                  id: "Load.FileImportStatus.FindByNamePlaceholder",
                })}
              />
            </Item>
          </Group>
        </SearchForm>
      </Panel>
    </>
  );
};

export default Search;

const StyledGrid = styled(Grid)` margin-top: 24px`;

const StyledDatePicker = styled(DatePicker)`
  flex: 1;
  .react-datepicker-wrapper{
  width: 100%;
}
`;
